<template>
    <footer class="w-full text-center text-gray-600 mt-5 py-5">
        &copy; 2016-2019 Viral New Service.
    </footer>
</template>

<script>
	export default {
		name: 'PageFooterMedia',
	}
</script>
